import React from 'react';
import styled from 'styled-components';

import Card from 'antd/es/card';
import Divider from 'antd/es/divider';

import Statistics from 'components/Statistics';

const StyledStatsCard = styled(Card)`
  background-color: #FFFFFF;
  border-radius: 8px;
  border: none;
  height: 100%;

  & .ant-card-body {
    height: 100%;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
`;

const StatsCard = ({ statistics = [], dividerIndices, onlyMiddleDivider, ...rest }) => {

  const shouldRenderDividerAfterIndex = (index) => {
    const isLast = index === statistics.length - 1;
    if (isLast) return false;

    if (Array.isArray(dividerIndices)) {
      return dividerIndices.includes(index);
    }

    if (onlyMiddleDivider && statistics.length % 2 === 0) {
      return index === (statistics.length / 2) - 1;
    }

    return true;
  };

  const renderDivider = (index) => {
    if (!shouldRenderDividerAfterIndex(index)) return null;

    if (onlyMiddleDivider) {
      return (
        <div
          className="stats-middle-divider"
          style={{
            alignSelf: 'center',
            width: 0,
            height: 30,
            borderLeft: '1px solid #EFF2F5',
            margin: '0 20px'
          }}
        />
      );
    }

    return (
      <Divider
        orientation="center"
        type="vertical"
      />
    );
  };

  return (
    <StyledStatsCard {...rest}>
      {
        statistics.map((stat, i) => (
          <React.Fragment key={i}>
            <Statistics {...stat} />
            {renderDivider(i)}
          </React.Fragment>
        ))
      }
    </StyledStatsCard>
  );
};

export default StatsCard;
